<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid class="m-0" v-if="!isLoading">
      <b-row v-if="showingIntro && taskStatus != 4 && form.isShowFormIntro">
        <b-col cols="8" offset="2">
          <div
            :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
            class="align-middle my-5"
          >
            <h3>
              {{
                form.formTitle
                  ? form.formTitle[selectedLanguage || "english"]
                  : "No Title"
              }}
            </h3>
            <div
              style="
                height: calc(100vh - 275px);
                overflow-y: auto;
                overflow-x: hidden;
              "
            >
              <!-- <p v-html="pageIntroText"></p> -->
              <p
                v-html="sanitizeHtml(
                  form.formIntroText
                    ? form.formIntroText[selectedLanguage || 'english']
                    : 'No Title'
                )"
              ></p>
            </div>

            <b-form-checkbox class="text-center my-3" v-model="userConsent">{{
              $t("questionnaires.consent")
            }}</b-form-checkbox>
            <b-button variant="outline-danger" class="mr-2" to="/dashboard">{{
              $t("questionnaires.backToDashboard")
            }}</b-button>
            <b-button
              variant="outline-success"
              :disabled="!userConsent"
              class="mr-2"
              @click="onClickProceed()"
              >{{ $t("questionnaires.proceed") }}</b-button
            >
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <!-- Left hand side container when form is submitted -->

        <!-- code disale for new branch -->
        <!-- <b-col cols="3" v-if="taskStatus == 4">
          <b-card header-tag="header" class="text-left">
            <template v-slot:header>
              <h6 class="mb-0">{{ $t("questionnaires.overview") }}</h6>
            </template>
            <b-card-text>
              <strong>{{ $t("questionnaires.dateOfAssigned") }}</strong>
              <br />
              {{ taskAssignedDate }}
            </b-card-text>
            <b-card-text>
              <strong>{{ $t("questionnaires.dateOfCompleted") }}</strong>
              <br />
              {{ taskCompletedDate }}
            </b-card-text>
            <b-card-text>
              <strong>{{ $t("questionnaires.download") }}</strong>
              <br />
              <a
                href="#"
                @click="downloadPdf(taskId, '/download/questionnaire')"
              >
                <font-awesome-icon
                  icon="file-pdf"
                  class="text-danger"
                  size="2x"
                />
              </a>
            </b-card-text>
            <b-button
              v-if="groupId != 16"
              variant="danger"
              @click="reOpenTask()"
              >Re-open</b-button
            >
          </b-card>
        </b-col> -->

        <!-- form card container -->
        <!-- :cols="taskStatus != 4 ? 9 : 6" -->
        
        <b-col  style="overflow: hidden">
          <!-- <b-progress
            height="10px"
            v-if="!showingIntro && taskStatus !=4"
            :value="progressValue"
            :max="progressMaxValue"
            variant="success"
            show-progress
          ></b-progress>-->

          <!-- :dir="$store.state.rightAlign ? 'rtl' : 'ltr'" -->
          <b-row :dir="$store.state.rightAlign ? 'rtl' : 'ltr'">
            <b-col class="text-center">
              <h3 class="mt-2">
                {{
                  form.formTitle
                    ? form.formTitle[selectedLanguage || "english"]
                    : "No Title"
                }}
              </h3>
              <p>
                {{
                  form.formDescription
                    ? form.formDescription[selectedLanguage || "english"]
                    : "No Description"
                }}
              </p>
            </b-col>
          </b-row>

          <div id="scrollspy" class="preview-scrollable-wrapper p-3">
            <div
              v-if="form.formSection.length"
              id="element"
              style="background-color: #f4f4f4"
            >
              <b-form v-if="!isLoading">
                <SectionContainer
                  v-for="(sectionData, index) in form.formSection"
                  :id="'section_' + index"
                  :isDisabled="isDisabled"
                  :isPreview="true"
                  :selectedLanguage="selectedLanguage"
                  :sectionData="sectionData"
                  :inputType="sectionData.inputType"
                  :key="index"
                  :counter="index"
                />
              </b-form>
            </div>
          </div>
          <b-row class="mt-3">
            <b-col cols="6" class="text-left">
              <a
                v-if="form.formSection.length"
                href="#"
                class="btn btn-warning"
                v-scroll-to="{
                  el: '#scrollspy',
                  container: '#scrollspy',
                  duration: 300,
                  easing: 'linear',

                  force: true,

                  x: false,
                  y: true,
                }"
              >
                <font-awesome-icon icon="angle-up" />
              </a>
            </b-col>
            <b-col v-if="$route.name == 'userform'">
              <!-- v-if="form.formSection.length && taskStatus !=4" -->

               <b-button v-if="$store.state.form1.isReadOnly == 1" class="float-right" to="/dashboard">
                {{ $t("questionnaires.backToDashboard")}}
              </b-button>

              <b-button-group class="float-right" v-else >
                <b-button
                  v-if="form.formSection.length && taskStatus != 4"
                  variant="outline-primary"
                  @click="onSavePostData"
                  :disabled="isLoading || isLoadingLocal"
                >
                  <span v-if="isLoading || isLoadingLocal">
                    <b-spinner small type="grow"></b-spinner>
                    {{ $t("savingProgressText") }}
                  </span>
                  <span v-else>{{ $t("saveProgressText") }}</span>
                </b-button>

                <!-- :isPreview="false" -->
                <b-button
                  v-if="form.formSection.length && taskStatus != 4"
                  variant="outline-success"
                  @click="onValidateSubmit"
                  >{{ $t("submitText") }}</b-button
                >
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- end of col-9 preview area righ sections list -->
        <b-col
          cols="3"
          class="mt-2"
          style="
            position: relative;
            overflow-y: auto;
            height: calc(100vh - 200px);
          "
        >
          <b-list-group v-b-scrollspy:scrollspy="50">
            <b-list-group-item
              :class="rightAlign ? 'text-right' : 'text-left'"
              v-for="(section, index) in form.formSection"
              :key="section.id"
              :active="currentSectionIndex === index"
              @click="onScrollClick(index)"
              button
            >
              <b-badge v-if="!rightAlign" variant="dark">{{
                index + 1
              }}</b-badge>
              &nbsp; {{ section.sectionTitle[selectedLanguage] }}
              <b-badge
                v-if="rightAlign && selectedLanguage == 'arabic'"
                variant="dark"
                >{{
                  new Intl.NumberFormat("ar-EG", {}).format(index + 1)
                }}</b-badge
              >
              <b-badge
                v-if="rightAlign && selectedLanguage == 'hebrew'"
                variant="dark"
                >{{ index + 1 }}</b-badge
              >
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <!-- review modal -->
      <b-modal
        :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
        :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
        id="modal-1"
        modal-header-close="No"
        :ok-title="$t('submitText')"
        :cancel-title="$t('cancelBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.submitModalTitle')"
        @ok="onSubmit"
      >
        <p>{{ $t("formSubmitingMessage") }}</p>
        <p></p>
      </b-modal>

      <b-modal
        :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
        id="modal-2"
        :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
        modal-header-close="No"
        ok-only
        :ok-title="$t('closeBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('questionnaires.formSubmittedModalTitle')"
        @ok="$router.replace('dashboard')"
      >
        <p>{{ $t("formSubmittedMessage") }}</p>
        <p></p>
      </b-modal>

      <b-alert
        :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
        :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000"
        variant="danger"
        dismissible
        solid
        >{{ $t("formValidationMessage") }}</b-alert
      >

      <b-modal
        id="modal-leave"
        modal-header-close="No"
        :ok-title="$t('closeBtnText')"
        :cancel-title="$t('cancelBtnText')"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        :title="$t('toast.title')"
        @ok="leaveConfirm = true"
      >
        <p>{{ $t("formLeaveAlertMessage") }}</p>
        <p></p>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import config from "./../configs/config";
import { Helper } from "../helpers";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionContainer from "../containers/SectionUserContainer";
import AppLoader from "../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../utils/HTTP";
import _ from "lodash";

export default {
  name: "UserFormPage",
  components: {
    SectionContainer,
    AppLoader,
  },
  data() {
    return {
      isDisabled: 0,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      groupId: null,
      inValidElements: [],
      inValidSections: [],
      leaveConfirm: false,
      initialResults: [],
      riskData: {
        percentage: null,
        risk: null,
        rating: null,
        color: null,
      },
      // progress bar
    };
  },

  mounted() {
    this.groupId = localStorage.getItem("userGroupId");
    this.taskId = localStorage.getItem("taskId");
    this.$store.state.validFields = true;
    //Redirect if taskid is empty
    if (!this.taskId) {
      this.$router.replace("/my-questionnaires");
      return false;
    }
    this.getTaskForm();
    // this.taskStatus = localStorage.getItem("activeTaskStatus");
    // this.userConsent = localStorage.getItem("userConsent") || false;
    // this.isDisabled = this.taskStatus == 4 ? 1 : 0;

    // } else {
    // 	this.viewUserForm();
    // 	this.initializeFormData();
    // 	this.$store.state.validFields = true;
    // }
  },

  beforeDestroy() {},

  beforeRouteLeave(to, from, next) {
    if (this.$route.name == "userform") {
      // console.log("leaving route..");
      if (this.fromButton || this.$store.state.form1.isReadOnly == 1) {
        next();
      } else {
        // this.$bvModal.show("modal-leave");
        const answer = window.confirm(this.$t("formLeaveAlertMessage"));
        if (answer) {
          // console.log("-------clear userFormSubmitArray--------- ");
          this.$store.state.userFormSubmitArray = [];
          this.$store.state.getUserFormSubmitArray = [];
          this.onResetLocalData();
          next();
        } else {
          next(false);
        }
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    }),

    ...mapState({
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    }),
  },

  watch: {
    selectedLanguage(lang) {
      this.updateTitles(lang);
    },
  },

  methods: {
    sanitizeHtml,
    ...mapActions(["setLanguage"]),
    ...mapMutations(["TOGGLE_LOADER"]),
    ...mapMutations(["UPDATE_FORM"]),

    async reOpenTask() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/reopen/" + this.taskId,
          { taskStatus: 1 },
          {
            Authorization: token,
          },
          null,
          true
        );
        this.$router.replace("/my-questionnaires");
      } catch {
        // console.log("------------erroror");
      }
    },

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
        h("b-spinner", { props: { type: "grow", small: true } }),
        // " We are generating your PDF... ",
        this.$t("toast.generatePDF"),
        h("b-spinner", { props: { type: "grow", small: true } }),
      ]);
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      });
    },

    async downloadPdf(taskId, route) {
      let titleForm = localStorage.getItem("task_title") + ".pdf";
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      this.makeToast();
      axios({
        url: config.API_URL + "v1/mytpp" + route + "/" + taskId,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
        data: { formDefaultLanguage: formDefaultLanguage },
      })
        .then((response) => {
          if (window.navigator.msSaveOrOpenBlob) {
            // let blob = response.data.blob;
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, titleForm);
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t("toast.successPDF"),
              this.$t("toast.title")
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", titleForm); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                this.$t("toast.successPDF"),
                this.$t("toast.title")
              );
            }
          }
        })
        .catch((error) => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            this.$t("toast.errorPDF"),
            this.$t("toast.title")
          );
        });
    },

    onClickProceed() {
      this.setUserConsent();
      this.setUserFormSchemaToStore();
      //this.initializeFormData();
    },

    onResetLocalData() {
      localStorage.removeItem("taskId");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("activeTaskStatus");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("examAttemptId");
      localStorage.removeItem("tempForm");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("userConsent");
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    async setUserConsent() {
      //let taskId = localStorage.getItem("taskId");
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/consent/" + this.taskId,
          { taskStatus: 1, userConsent: this.userConsent },
          {
            Authorization: token,
          },
          null,
          true
        );
      } catch {
        // console.log("------------erroror");
      }
      this.showingIntro = false;
    },

    initializeFormData() {
      // console.log("------initializeFormData---------- ");
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      this.$store.state.progressMaxValue = 0;
      if (
        this.$store.state.getUserFormSubmitArray &&
        this.$store.state.getUserFormSubmitArray.length
      ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        this.$store.state.progressMaxValue = this.$store.state.getUserFormSubmitArray.length;
        this.calculateProgressValue(this.$store.state.getUserFormSubmitArray);
        // console.log("loading previously saved data....");
      } else {
        // console.log("loading new data....");
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep(this.form);
        tempForm.formSection.map((section, index) => {
          section.formElements.map((element, elementIndex) => {
            // let dataAttributes = element.dataAttributes.find(opt => opt.dataAttributeKey == 'weightage')
            // // console.log("element", element)
            this.$store.state.progressMaxValue += 1;
            this.$store.state.userFormSubmitArray.push({
              elements: [],
              sectionId: section.id,
              sectionIndex: section.index,
              elementIndex: elementIndex,
              elementId: element.id,
              elementInputType: element.inputType,
              // elementTitle: element.label[this.selectedLanguage],
              // sectionTitle: section.sectionTitle[this.selectedLanguage]
              elementTitle: element.label,
              elementTitleAbb: element.abbreviationLabelText || element.label,
              question_abb_table: element.labelForTable || null,
              sectionTitle: section.sectionTitle,
              language: formDefaultLanguage,
              isMultiSelect: element.configuration
                ? element.configuration.isMultipleSelect
                  ? 1
                  : 0
                : 0,
              weightage: element.weightage || null,
              dataAttributes: element.dataAttributes || null,
              selectedChart: element.selectedCharts || null,
              isWorkFlowNa: element.isNa && element.isNa == 1 ? 1 : 0,
              isHyperLink: element.isHyperLink ? 1 : 0,
              hyperLinkUrl: element.hyperLinkUrl || null,
              hyperLinkText: element.hyperLinkText || null,
              hyperLinkTextBefore: element.hyperLinkTextBefore || null,
              hyperLinkTextAfter: element.hyperLinkTextAfter || null,
              isHiddenElement: element.isHidden && element.isHidden ? 1 : 0,
              isHiddenSection: section.isHidden && section.isHidden ? 1 : 0,
              enableFilterForManageThirdParty:
                (element &&
                  parseInt(element.enableFilterForManageThirdParty)) ||
                0,
              enableSelfReportingForManageThirdParty:
                (element &&
                  parseInt(element.enableSelfReportingForManageThirdParty)) ||
                0,
              enableSelfReportingForThirdPartyProfile:
                (element &&
                  parseInt(element.enableSelfReportingForThirdPartyProfile)) ||
                0,
            });
          });
        });
        // location.reload();
      }

      // EventBus.$emit("onUpdateValues", "form submit");
      // this.getSavedData();
    },

    updateTitles(lang) {
      // console.log("lang", lang);
      const dd = this.$store.state.userFormSubmitArray;
      let array2 = dd.map((a) => {
        // let returnValue = { ...a };
        return (a.language = lang);
        // return returnValue;
      });
    },

    calculateProgressValue(array) {
      const registerData = _.clone(this.$store.state.registerData);
      for (let i = 0; i < array.length; i++) {
        // this.$store.state.progressValue += array[i].elements.length
        // // console.log("asasas", array[i].elements[0]);

        if (
          array[i] &&
          array[i].elements &&
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.length
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        } else {
          // delete registerData[array[i].elementId];
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].length &&
          array[i].elements[0][0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.phone
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }

        // else {
        //   delete registerData[array[i].elementId];
        // }
        // main calculations :p
      }
      // // console.log("asasas", registerData);
      this.$store.state.registerData = registerData;
      let numkeys = Object.keys(registerData).length;
      this.$store.state.progressValue = numkeys;
    },

    changeLanguage() {
      let tt = this.selected.toLowerCase();
      this.setLanguage(tt);
      this.TOGGLE_LOADER(100);
    },

    setUserFormSchemaToStore() {
      let form = JSON.parse(localStorage.getItem("activeFormSchema"));
      let taskdata = JSON.parse(localStorage.getItem("taskFormData"));
      this.updateFormToStore(form);
    },

    updateFormToStore(form) {
      this.UPDATE_FORM(form);
      // this.reloadTable();
    },

    onValidateSubmit() {
      // // console.log("userFormSubmitArray", this.$store.state.userFormSubmitArray);
      EventBus.$emit("onSubmitEndUserForm", "form submit");
      // console.log("userFormSubmitArray", this.$store.state.validFields)
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    checkForInValidFields() {
      let isValid = false;
      outerLoop: for (
        let i = 0;
        i < this.$store.state.form1.formSection.length;
        i++
      ) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            // // console.log("inside checkForInValidFields looop",this.$store.state.form1.formSection[i].formElements[x]);
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x]
                .id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            console.clear();
            EventBus.$emit("OnInvalidFieldCatch", inValidData);
            this.showErrorToast = true;
            isValid = false;
            console.clear();
            console.log("inValidElements", this.inValidElements);
            // console.log("inValidSections",this.inValidSections);
            break outerLoop;
          }
          isValid = true;
        }
      }
      //   });
      if (isValid) {
        // console.log("if valid true", isValid);
        // // console.log("if valid true", this.$store.state.userFormSubmitArray);
        this.onReviewSubmit();
      }

      //    let oo = _.find(section.formElements, 'isInValid');
      //    // console.log("oo", oo)
      // section.formElements.map((element, elementIndex) => {
      //   // console.log("ina-----valiiiid", element.isInValid);

      // });
    },

    getInvalidFields() {
      this.inValidElements = [];
      this.inValidSections = [];
      for (let i = 0; i < this.$store.state.form1.formSection.length; i++) {
        for (
          let x = 0;
          x < this.$store.state.form1.formSection[i].formElements.length;
          x++
        ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            // // console.log("inside checkForInValidFields looop",this.$store.state.form1.formSection[i].formElements[x].id);
            this.inValidElements.push(
              this.$store.state.form1.formSection[i].formElements[x]
            );
            // this.inValidSections.push(this.$store.state.form1.formSection[i])
          }
        }
      }
    },

    onReviewSubmit() {
      // // console.log("validFields", this.$store.state.validFields);
      // // console.log("userFormSubmitArray", this.$store.state.userFormSubmitArray);
      if (this.$store.state.validFields) {
        this.showErrorToast = false;
        this.$bvModal.show("modal-1");
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit() {
      // this.calculateRiskScore();
      this.calculateHighestScoreForCategory();
      this.riskData = {
        ...this.riskData,
        data: this.initialResults,
      };
      console.log("---Risk Data after form Submission----", this.riskData);

      // temp disabe function to veri score, disabling the submit 
      this.saveFormData(4); 
    },

    checkExistanceCountry() {
      console.log("----------checkExistanceCountry-----------");
      let sections = this.$store.state.form1.formSection;
      let sec4score = null;

      let compareSectionSix = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );
      let sectionFour = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );
      let foundSectionFourEle = this.$store.state.userFormSubmitArray.find(
        (ele) => ele.elementId == sectionFour.formElements[0].id
      );

      if (compareSectionSix) {
        let found = compareSectionSix.formElements.find(
          (a) => a.inputType == "countries"
        );

        if (found) {
          let foundSectionSixEle = this.$store.state.userFormSubmitArray.find(
            (ele1) => ele1.elementId == found.id
          );

          // console.log("foundSectionSixEle", foundSectionSixEle)
          // console.log("foundSectionFourEle", foundSectionFourEle)

          if (foundSectionFourEle) {
            sec4score = foundSectionFourEle.elements.find((ele) => ele);
          }

          // console.log("sec4score", sec4score)


          if (foundSectionSixEle && foundSectionSixEle.elements.length) {
            // foundEle.elements.find((ele) => (ele.score = 0));

            foundSectionSixEle.elements.find((ele) => {
              // console.log("foundSectionSixEle", ele)
              if ((foundSectionFourEle.isHiddenElement == 0 && ele.score == 13 && sec4score)) {
                ele.score = 0;
                sec4score.score = 13;
              } else if (foundSectionFourEle.isHiddenElement == 0 && ele.score && sec4score && sec4score.score == 0) {
                sec4score.score = 0

              } else {
                ele.score = 0;
              }
            });
          } else{
            sec4score.score = sec4score.postValue[0].riskScore
          }

          let highestScore = found.dataAttributes.find(
            (atr) => atr.dataAttributeKey == "highest_score"
          );
          highestScore.dataAttributeValue = 0;
        }
      }

          // console.log("sec4score", sec4score)


      // let eleNew = this.$store.state.userFormSubmitArray.find(
      //   (ele) => ele.elementId == compareSection.formElements[0].id
      // );

      // console.log("ele new----", eleNew);
      // this.$store.state.form1.formSection.map((section) => {
      //   section.formElements.map((element) => {
      //     if (element.dataAttributes) {
      //       let highestScore = element.dataAttributes.find(
      //         (ele) => ele.dataAttributeKey == "highest_score"
      //       );
      //       if (highestScore) {
      //         console.log("checkExistanceCountry == true");
      //         highestScore.dataAttributeValue = 0;
      //       }
      //     }
      //   });
      // });

      // if (eleNew && eleNew.elements && eleNew.elements.length) {
      //   console.log("checkExistanceCountry filled == true");
      //   let highestScore = eleNew.dataAttributes.find(
      //     (atr) => atr.dataAttributeKey == "highest_score"
      //   );

      //   if (highestScore) {
      //     highestScore.dataAttributeValue = 0;
      //   }
      // }
    },

    calculateHighestScoreForCategory() {
      // console.log("0wqjnwlqjnw kjwkqj;wkxw")
      let topics = [],
        foundScore = 0;
      this.checkExistanceCountry();
      // this.$store.state.userFormSubmitArray.map((element, index) => {
      //   if (
      //     element.elements &&
      //     element.elements.length &&
      //     element.dataAttributes
      //   ) {
      //     foundScore = element.elements.find((ele) => ele);
      //     console.log("element", element.score);
      //   }
      // });
      // console.log("foundScore ----", foundScore);

      this.$store.state.form1.formSection.map((section) => {
        section.formElements.map((element) => {
          // console.log("element : ", element);

          if (element.dataAttributes) {
            let topic = element.dataAttributes.find(
              (ele) => ele.dataAttributeKey == "topic"
            );
            let highestScore = element.dataAttributes.find(
              (ele) => ele.dataAttributeKey == "highest_score"
            );

            if (highestScore && highestScore.dataAttributeValue != 0) {
              let hh = parseFloat(highestScore.dataAttributeValue) || 0;
              // let ss = (foundScore.score && parseFloat(foundScore.score)) || 0;

              topics.push({
                topic: (topic && topic.dataAttributeValue) || null,
                weightage: parseFloat(element.weightage),
                actualScore: 0,
                highestScore1: hh,
              });
            }
          }
        });
      });

      // console.log("topics : ", topics);

      const newTopicsArr = [];
      const newTopicsIdArr = [];
      for (const topic of topics) {
        const index = newTopicsIdArr.indexOf(topic.topic);
        if (index >= 0) {
          newTopicsArr[index].actualScore += topic.actualScore;
          newTopicsArr[index].highestScore1 += topic.highestScore1;
        } else {
          newTopicsIdArr.push(topic.topic);
          newTopicsArr.push(topic);
        }
      }
      // console.log("newTopicsArr : ", newTopicsArr);
      // return newTopicsArr
      this.calculateRiskScore(newTopicsArr);
    },

    calculateRiskScore(highestScoress) {
      // console.clear();
      this.initialResults = [];
      let score = 0,
        weightage = 0,
        topics = [],
        initialResults = [],
        topicKeys = [],
        sumOfScores = 0;
      this.$store.state.userFormSubmitArray.map((element, index) => {
        // console.log("elemee----", element.elements);
        if (element.dataAttributes) {
          let foundScore = element.elements.find((ele) => ele);
          let topic = element.dataAttributes.find(
            (ele) => ele.dataAttributeKey == "topic"
          );
          let highestScore = element.dataAttributes.find(
            (ele) => ele.dataAttributeKey == "highest_score"
          );

          // console.log("foundScore ----", foundScore )
          // if(foundScore.score == null){
          // console.log("foundScore ----", foundScore )
          // }

          if (
            foundScore &&
            highestScore &&
            highestScore.dataAttributeValue != 0
          ) {
            let hh = parseFloat(highestScore.dataAttributeValue) || 0;
            let ss = (foundScore.score && parseFloat(foundScore.score)) || 0;

            // console.log("highestScore:->", hh + topic.dataAttributeValue) ;
            // console.log("actual score -->", ss + topic.dataAttributeValue);
            // console.log("------");

            topics.push({
              topic: (topic && topic.dataAttributeValue) || null,
              weightage: parseInt(element.weightage),
              actualScore: ss,
              highestScore1: hh,
            });
          }
        }
      });
      // console.log("topics", topics);
      const newTopicsArr = [];
      const newTopicsIdArr = [];
      for (const topic of topics) {
        const index = newTopicsIdArr.indexOf(topic.topic);
        if (index >= 0) {
          newTopicsArr[index].actualScore += topic.actualScore;
          // newTopicsArr[index].highestScore1 = tt.highestScore1;
        } else {
          newTopicsIdArr.push(topic.topic);
          newTopicsArr.push(topic);
        }
      }

      newTopicsArr.map((a) => {
        let y = highestScoress.find((t) => t.topic == a.topic);
        // console.log("a", y );
        return (a.highestScore1 = y.highestScore1);
      });
      // console.clear();
      console.log("newTopicsArr : ", newTopicsArr);
      initialResults = newTopicsArr.map((ele) => {
        let finalScoreForTopic =
          (ele.actualScore / ele.highestScore1) * ele.weightage;
        this.analyseTopicRiskData(
          ele.actualScore,
          ele.topic,
          finalScoreForTopic
        );
        return {
          ...ele,
          finalScoreForTopic,
          data: this.riskData,
        };
      });

      // initialResults = initialResults.map((ele) => {
      //   this.analyseRiskData(ele.finalScoreForTopic);
      // });

      this.initialResults = initialResults;
      let sum = initialResults.reduce(
        (accum, item) => accum + item.finalScoreForTopic,
        0
      );

      // console.log("sum", sum);
      // sum = 88;
      this.analyseRiskData(sum);
    },

    analyseRiskData(sum) {
      switch (true) {
        case sum >= 0 && sum < 5:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score : 1");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "1",
          };
          break;
        case sum >= 5 && sum < 15:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 2");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "2",
          };
          break;

        case sum >= 15 && sum < 25:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 3");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "3",
          };
          break;

        case sum >= 25 && sum < 35:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 4");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "4",
          };
          break;

        case sum >= 35 && sum < 45:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 5");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "5",
          };
          break;
        case sum >= 45 && sum < 55:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 6");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "6",
          };
          break;
        case sum >= 55 && sum < 65:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 7");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "7",
          };
          break;
        case sum >= 65 && sum < 75:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 8");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "8",
          };
          break;
        case sum >= 75 && sum < 85:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 9");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "9",
          };
          break;
        case sum >= 85 && sum <= 100:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 10");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "10",
          };
          break;

        default:
          // console.log("%", sum);
          // console.log("Risk : Invalid");
          // console.log("color : Invalid");
          // console.log("Score: Invalid");
          this.riskData = {
            percentage: sum,
            risk: "Invalid",
            rating: "Invalid",
            color: "Invalid",
          };
      }
    },

    analyseTopicRiskData(sum, topic, percentage) {
      switch (topic) {
        case "jurisdiction":
          {
            if (sum > 12 && sum <= 18) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if (sum > 4 && sum <= 12) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if (sum >= 0 && sum <= 4) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "activity":
          {
            if (sum > 15 && sum <= 32) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if (sum > 5 && sum <= 15) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if (sum >= 0 && sum <= 5) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "workforce":
          {
            if (sum > 14) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if (sum >= 0 && sum <= 14) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "policies_and_systems":
          {
            if (sum > 10 && sum <= 13) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if (sum > 6 && sum <= 10) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if (sum >= 0 && sum <= 6) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "human_rights":
          {
            if (sum > 10 && sum <= 13) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if (sum > 4 && sum <= 10) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if (sum >= 0 && sum <= 4) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
      }
    },

    async saveFormData(status) {
      let userId = localStorage.getItem("userId");
      let taskId = localStorage.getItem("taskId");
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      // // console.log("this.$store.state.userFormSubmitArray", this.$store.state.userFormSubmitArray)
      let taskData = this.$store.state.userFormSubmitArray;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/submitform",
          {
            userId: userId,
            taskData: taskData,
            status: status,
            taskId: taskId,
            riskData: {
              ...this.riskData,
              data: this.initialResults,
            },
            formDefaultLanguage: formDefaultLanguage,
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        if (result) {
          this.fromButton = true;
          this.$bvModal.show("modal-2");
        }
      } catch {
        this.fromButton = true;
        this.$bvModal.show("modal-2");
        // console.log("------------erroror");
      }
    },

    onScrollClick(index) {
      // console.log("index", index);
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },

    // auto save logic for user form--------
    async onSavePostData() {
      EventBus.$emit("onSubmitEndUserForm", "progress");
      // console.clear();
      this.isLoadingLocal = true;
      // console.log("saving data...-----");
      // let aa = _.isEqual(this.$store.state.userFormSubmitArray, this.$store.state.getUserFormSubmitArray)
      // // console.log("userFormSubmitArray...", this.$store.state.userFormSubmitArray);

      let token = "Bearer " + localStorage.getItem("accessToken");
      let taskData = this.$store.state.userFormSubmitArray;
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/save/" + this.taskId,
          { taskData: taskData },
          {
            Authorization: token,
          },
          null,
          false
        );
        this.isLoadingLocal = false;
        Helper.makeToast(
          this.$bvToast,
          "success",
          this.$t("toast.saveSuccess"),
          this.$t("toast.title")
        );
      } catch {
        this.isLoadingLocal = false;
        Helper.makeToast(this.$bvToast, "danger", this.$t("toast.saveError"));
        // console.log("------------erroror");
      }
    },

    checkForNewUser(data) {
      // let array = this.$store.state.getUserFormSubmitArray;
      // console.log("checkForNewUser", this.$store.state.getUserFormSubmitArray);
      let array = data;
      let aa = array.find((ele) => ele.elements);
      // console.log("aa", aa)
      if (aa) {
        return true;
      } else {
        return null;
      }
    },

    async getTaskForm() {
      let userId = localStorage.getItem("userId");
      let taskId = localStorage.getItem("taskId");
      localStorage.removeItem("activeFormSchema");
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "v1/mytpp/task/" + taskId,
        {
          userId: userId,
          formType: 1,
        },
        {
          Authorization: token,
        },
        null,
        true
      );

      if (result.data.task && result.data.task) {
        console.clear();
        // alert(result.data.task.task_status);
        let form = result.data.task.form.schema;
        let form_data = JSON.parse(result.data.task.form_data);
        this.taskFiles = result.data.task.files;
        // // console.log("result.data.task.form", JSON.parse(result.data.task.form_data));
        // // console.log("form_schema---------", JSON.parse(form));
        // // console.log("result.data.task.form", form_data.user_data);

        if (form_data && form_data.hasOwnProperty("user_data")) {
          // console.log("result.data.task.form", form_data.user_data);
          let found = this.checkForNewUser(form_data.user_data);
          console.log("found user exist", found);
          if (found) {
            console.log("data found---------");
            this.$store.state.getUserFormSubmitArray = form_data.user_data;
            // console.log("result.data.getUserFormSubmitArray.form", this.$store.state.getUserFormSubmitArray);
          } else {
            this.$store.state.getUserFormSubmitArray = [];
          }
        }

        if (this.taskStatus == 4) {
          this.taskAssignedDate = result.data.task.created_at;
          this.taskCompletedDate = result.data.task.updated_at;
        }

        if (
          form_data &&
          form_data.hasOwnProperty("user_consent") &&
          form_data.user_consent == 1
        ) {
          this.showingIntro = false;
        } else {
          this.showingIntro = true;
        }
        //localStorage.setItem("activeFormId", form.formId);
        localStorage.setItem("activeFormSchema", form);
        localStorage.setItem("activeTaskStatus", result.data.task.task_status);
        this.setUserFormSchemaToStore();
        this.initializeFormData();
        let ff = JSON.parse(form);
        // this.taskStatus = result.data.task.task_status;
        this.taskStatus = 4;
        this.isDisabled = this.taskStatus == 4 ? 1 : 0;
        if (ff.isShowFormIntro) {
          this.pageIntroText = ff.formIntroText[this.selectedLanguage];
        }
      }
    },
  },

  // backup function for calculate score
  // calculateRiskScore() {
  //   console.clear();
  //   this.initialResults = [];
  //   let score = 0,
  //     weightage = 0,
  //     topics = [],
  //     initialResults = [],
  //     topicKeys = [],
  //     sumOfScores = 0;
  //   this.$store.state.userFormSubmitArray.map((element, index) => {
  //     // console.log("elemee----", element.elements);
  //     if (element.dataAttributes) {
  //       let foundScore = element.elements.find((ele) => ele);
  //       let topic = element.dataAttributes.find(
  //         (ele) => ele.dataAttributeKey == "topic"
  //       );
  //       let highestScore = element.dataAttributes.find(
  //         (ele) => ele.dataAttributeKey == "highest_score"
  //       );

  //       // console.log("foundScore ----", foundScore )
  //       // if(foundScore.score == null){
  //       // console.log("foundScore ----", foundScore )
  //       // }

  //       if (
  //         foundScore &&
  //         highestScore &&
  //         highestScore.dataAttributeValue > 0
  //       ) {
  //         let hh = parseFloat(highestScore.dataAttributeValue);
  //         let ss = (foundScore.score && parseFloat(foundScore.score)) || 0;

  //         // console.log("highestScore:->", hh + topic.dataAttributeValue) ;
  //         // console.log("actual score -->", ss + topic.dataAttributeValue);
  //         // console.log("------");

  //         topics.push({
  //           topic: (topic && topic.dataAttributeValue) || null,
  //           weightage: parseInt(element.weightage),
  //           actualScore: ss,
  //           highestScore1: hh,
  //         });
  //       }
  //     }
  //   });
  //   console.log("topics", topics);
  //   const newTopicsArr = [];
  //   const newTopicsIdArr = [];
  //   for (const topic of topics) {
  //     const index = newTopicsIdArr.indexOf(topic.topic);
  //     if (index >= 0) {
  //       newTopicsArr[index].actualScore += topic.actualScore;
  //       newTopicsArr[index].highestScore1 += topic.highestScore1;
  //     } else {
  //       newTopicsIdArr.push(topic.topic);
  //       newTopicsArr.push(topic);
  //     }
  //   }
  //   // console.log('newTopicsArr : ',newTopicsArr);
  //   initialResults = newTopicsArr.map((ele) => {
  //     let finalScoreForTopic =
  //       (ele.actualScore / ele.highestScore1) * ele.weightage;
  //     this.analyseRiskData(finalScoreForTopic);
  //     return {
  //       ...ele,
  //       finalScoreForTopic,
  //       data: this.riskData,
  //     };
  //   });

  //   // initialResults = initialResults.map((ele) => {
  //   //   this.analyseRiskData(ele.finalScoreForTopic);
  //   // });

  //   this.initialResults = initialResults;
  //   let sum = initialResults.reduce(
  //     (accum, item) => accum + item.finalScoreForTopic,
  //     0
  //   );

  //   // console.log("sum", sum);
  //   // sum = 88;
  //   this.analyseRiskData(sum);
  // },
};
</script>
<style scoped>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 240px);
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>

